import Button from '@/components/Button/Button';

interface DeleteRowPopupProps {
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteRowPopup = ({ onConfirm, onCancel }: DeleteRowPopupProps) => {
  return (
    <div>
      <p className="text-sm text-ds-gray-500">
        You’re about to delete this row. This action cannot be undone. Are you sure you want to
        continue?
      </p>
      <div className="mt-4 flex justify-end gap-2">
        <Button color="outlined" size="sm" onClick={onCancel}>
          Cancel
        </Button>
        <Button size="sm" color="error" type="button" onClick={onConfirm}>
          Delete
        </Button>
      </div>
    </div>
  );
};

export default DeleteRowPopup;
